import { render, staticRenderFns } from "./modal-top-info-box.vue?vue&type=template&id=0ac8f6d2"
import script from "./modal-top-info-box.vue?vue&type=script&lang=ts"
export * from "./modal-top-info-box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports